import { lazy, Suspense } from 'react'
import { createBrowserRouter, Outlet } from 'react-router-dom'
import UserAuthorizationHandler from '../components/authorization/UserAuthorizationHandler'
import { invoiceSearchRoutes } from './invoiceSearch'
import { userManagementRoutes } from './userManagement'
import { fixationsRoutes } from './fixations'
import { orderTrackingRoutes } from './orderTracking'
import { tollingAccountRoutes } from './tollingAccount'
import { financialExposureRoutes } from './financialExposure'
import { qualityCertificationRoutes } from './qualityCertification'

const HomePage = lazy(() => import('../containers/Homepage/HomepageContainer'))
const LoginPage = lazy(() => import('../containers/LoginContainer'))
const RegistrationPage = lazy(() => import('../containers/Registration/RegistrationContainer'))
const WaitingConfPage = lazy(() => import('../containers/WaitingAccountConfContainer'))
const NotFoundPage = lazy(() => import('../containers/NotFoundContainer'))

export const ROOT_PATHS = {
  HOME: '/',
  REGISTRATION: '/registration',
  WAITING_CONF: '/waiting-confirmation',
  LOGIN: '/login',
} as const

export const router = createBrowserRouter([
  {
    path: ROOT_PATHS.HOME,
    element: (
      <UserAuthorizationHandler>
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </UserAuthorizationHandler>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: ROOT_PATHS.LOGIN,
        element: <LoginPage />,
      },
      {
        path: ROOT_PATHS.REGISTRATION,
        element: <RegistrationPage />,
      },
      {
        path: ROOT_PATHS.WAITING_CONF,
        element: <WaitingConfPage />,
      },
      ...userManagementRoutes,
      ...fixationsRoutes,
      ...orderTrackingRoutes,
      ...financialExposureRoutes,
      ...tollingAccountRoutes,
      ...invoiceSearchRoutes,
      ...qualityCertificationRoutes,
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
